module.exports = __webpack_public_path__ + "img/fccpc_cer.5c759466.png";